export function ObjectToArray(obj: { [key: string]: string } | string[]): string[] {
  return Object.values(obj ?? {}).filter(Boolean)
}
